export const [EMPRESA, UNIVERSIDAD, EXTERNAL, CXVET] = ["Empresa", "Universidad", "External", "CxVet"]
export const ORGANIZATION_TYPES = [EMPRESA, UNIVERSIDAD]
export const DIPLOMADO_TYPES = [EXTERNAL, CXVET]

export const [ACCESO_LIBRE, ACCESO_CONTROLADO] = ["Acceso libre", "Acceso controlado"];
export const ACCESS_TYPES = [ACCESO_LIBRE, ACCESO_CONTROLADO];

export const [GUEST, GRATIS, PREMIUM, LEGACY, ADMIN] = ["Gest", "Gratis", "Premium", "Legacy", "Admin"];
export const USER_TYPES_BASIC = [GRATIS, PREMIUM];
export const USER_TYPES_ADMIN = [GRATIS, PREMIUM, ADMIN];
export const USER_TYPES_PREMIUM = [PREMIUM, ADMIN];
export const USER_TYPES_ALL = [GUEST, GRATIS, PREMIUM, LEGACY, ADMIN];

export const CXVET_VIDEO_TYPES = USER_TYPES_BASIC
export const SPECIES_TYPES = ["Perro", "Gato", "Otras especies"];

export const ACCEPTED_IMAGES = "image/jpeg,image/jpg,image/png"
export const ACCEPTED_VIDEOS = "video/ogg,video/mp4,video/webm"
export const ACCEPTED_FILES = "application/pdf"
export const IMAGE_TYPES = ACCEPTED_IMAGES.split(",")
export const VIDEO_TYPES = ACCEPTED_VIDEOS.split(",")
export const FILE_TYPES = ACCEPTED_FILES.split(",")

export const REQUIRED_INPUT_MESSAGE = "Debes llenar este campo.";
export const REQUIRED_SELECT_MESSAGE = "Debes seleccionar un valor";
export const VALID_FORMAT_MESSAGE = "Introduce un formato válido."

export const [ALL_USERS, ONLY_PREMIUM, ONLY_GRATIS, ONLY_NOT_REGISTERED] = ["Todos los usuarios", "Solo Premium", "Solo básicos", "Solo No Registrados"]
export const ANALYTICS_USER_FILTER_OPTIONS = [ALL_USERS, ONLY_PREMIUM, ONLY_GRATIS, ONLY_NOT_REGISTERED];
export const ANALYTICS_USER_FILTER_MAP = {
    [ONLY_PREMIUM]: PREMIUM,
    [ONLY_GRATIS]: GRATIS,
    [ONLY_NOT_REGISTERED]: GUEST
}

export const DEFAULT_LANGUAGE = "es";
export const SUPPORTED_LANGUAGES = ["es", "en", "fr", "pt", "de", "it"];
export const MAX_TRANSLATIONS_PER_PROCEDURE = 6;

export const LANGUAGE_NAMES = {
    es: "Español",
    en: "Inglés",
    fr: "Francés",
    pt: "Portugués",
    de: "Alemán",
    it: "Italiano"
};

export const LANGUAGE_NAMES_IN_THEIR_LANGUAGE = {
    es: "Español",
    en: "English",
    fr: "Français",
    pt: "Português",
    de: "Deutsch",
    it: "Italiano"
};

export const FILTER_ALL = "Todas";
export const FILTER_UNIVERSITIES = "Universidades y escuelas de medicina veterinaria";
export const FILTER_COMPANIES = "Empresas avaladas por el Instituto de Cirugía Veterinaria";
export const FILTER_ORGANIZATIONS = "Organizaciones";

export const FILTER_TYPE_ALL = "ALL";
export const FILTER_TYPE_UNIVERSITIES = "UNIVERSITIES";
export const FILTER_TYPE_COMPANIES = "COMPANIES";
export const FILTER_TYPE_ORGANIZATION = "ORGANIZATION";